import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core'
import { provideRouter } from '@angular/router'
import { routes } from './routes'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { CorrelationInterceptor } from './shared/interceptors/correlation-interceptor'
import { LoadingSpinnerInterceptor } from './shared/interceptors/loading-spinner-interceptor'
import { AuthCheckInterceptor } from './shared/interceptors/auth-check-interceptor'
import { BaseUrlInterceptor } from './shared/interceptors/base-url-interceptor'
import { HeadersInterceptor } from './shared/interceptors/headers-interceptor'
import { DateInterceptor } from './shared/interceptors/date-interceptor'
import { CurrencyPipe, DatePipe, PercentPipe } from '@angular/common'
import { AccountNumberPipe } from './shared/pipes/accountNumber.pipe'
import { UserService } from './public/user/service/user.service'
import { NumberInterceptor } from './shared/interceptors/number-interceptor'

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: CorrelationInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingSpinnerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthCheckInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DateInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: NumberInterceptor, multi: true },
    DatePipe,
    CurrencyPipe,
    PercentPipe,
    AccountNumberPipe,
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => inject(UserService).getUser()),
    provideRouter(routes),
  ],
}
